import { Observable } from 'rxjs';
import { ServerDataSource } from 'angular2-smart-table';
import { EntityConfigTemplate } from './common/entity-config.interface';

export interface SalaryStructure {
  id?: number;
  documentId?: string;
  name: string;
  payFrequency?: 'Monthly' | 'Bimonthly' | 'Fortnightly' | 'Weekly' | 'Daily';
  erpnextStructureId?: string;
}

export const SalaryStructureConfig: EntityConfigTemplate = {
  meta: {
    entityName: 'salary-structure',
    entityPluralName: 'salary-structures',
    titleField: 'name',
    view: false,
    selectFilter: { isActive: true }
  },
  name:              { title: 'Name' },
  payFrequency:      { title: 'Pay Frequency' },
  erpnextStructureId:{ title: 'Payroll ID', view: { list: false } },
};

export abstract class SalaryStructureData {
  abstract get gridDataSource(): ServerDataSource;
  abstract listAll(config?: any): Observable<SalaryStructure[]>;
  abstract list(pageNumber: number, pageSize: number): Observable<SalaryStructure[]>;
  abstract get(id: string): Observable<SalaryStructure>;
  abstract update(record: SalaryStructure): Observable<SalaryStructure>;
  abstract create(record: Partial<SalaryStructure>): Observable<SalaryStructure>;
  abstract delete(id: string): Observable<boolean>;
}
